import { PageContainer, SmallPaddingCard } from '@/components'
import styled from 'styled-components'
// import { WAFResource } from './waf_resource'
import SiteList from './site-list'
const WafResource = () => (
  <PageContainer>
    <UserContainer>
      <SiteList />
    </UserContainer>
  </PageContainer>
)

export default WafResource
const UserContainer = styled.div`
  width: 100%;
`
